import { ref as c, nextTick as d } from "vue";
import { isKorean as u } from "./index711.js";
function h({
  afterComposition: p,
  emit: n
}) {
  const t = c(!1), r = (o) => {
    n?.("compositionstart", o), t.value = !0;
  }, i = (o) => {
    var a;
    n?.("compositionupdate", o);
    const l = (a = o.target) == null ? void 0 : a.value, e = l[l.length - 1] || "";
    t.value = !u(e);
  }, s = (o) => {
    n?.("compositionend", o), t.value && (t.value = !1, d(() => p(o)));
  };
  return {
    isComposing: t,
    handleComposition: (o) => {
      o.type === "compositionend" ? s(o) : i(o);
    },
    handleCompositionStart: r,
    handleCompositionUpdate: i,
    handleCompositionEnd: s
  };
}
export {
  h as useComposition
};
